/* Copyright (c) Trimble Inc. All rights reserved. */


import AlertService from 'legacy-components/alert/AlertService';
import { AsyncActionState } from 'legacy-components/form/action/AsyncAction';
import { useEffect, useCallback, useState, useContext } from 'react';
import { resolveAPIErrorMessage } from '../error-message/ErrorMessage';
import { Box, Button, Dialog, Grid, TextField, Typography } from '@material-ui/core';
import Submit from '../form/submit/Submit';
import { notBlank } from 'libs/utils/shared/common';
import React from 'react';
import { Alert } from '@material-ui/lab';
import { InputContainer } from '../form/input-container/InputContainer';
import { SnackNotificationContext } from 'legacy-components/notifications/GenericSnackNotification';
 
  export interface DataRemoverDialogProps {
    open: boolean;
    toggle: () => void;
    title?: string;
    id?: string;
    message?: string | JSX.Element;
    confirmationText?: string;
    skipButtonText?: string | JSX.Element;
    confirmationButtonText?: string | JSX.Element;
    asyncActionState?: AsyncActionState;
    onConfirm?: () => void;
    onSuccess?: () => void;
    successMessage?: string | JSX.Element;
    customErrorMessage?: string | JSX.Element;
    placeholder?: string ;
  }
  export const DataRemoverDialog: React.FC<DataRemoverDialogProps> = ({
    open,
    toggle,
    title = 'Remove',
    id = 'DATA_REMOVER',
    message,
    confirmationText,
    confirmationButtonText = (
     "Confirm"
    ) as unknown as string,
    skipButtonText = (
      "Cancel"
    ) as unknown as string,
    asyncActionState,
    onSuccess,
    onConfirm,
    customErrorMessage = 'Unknown error occured on deletion',
    successMessage = `Removed {{confirmationText}} ...`,
    placeholder,
  }) => {
    const [userText, setUserText] = useState<string>('');
  
    const notification = useContext(SnackNotificationContext);
    useEffect(() => {
      if (asyncActionState?.loaded) {
        onSuccess && onSuccess();
        toggle();
        notification.show({
          id: 'data-remover',
          message: successMessage as any,
          timeout: 4000,
        });
      }
    }, [asyncActionState?.loaded]);

    useEffect(() => {

      if (asyncActionState?.error && asyncActionState?.errorValue) {
        toggle();
        notification.show({
          id: 'data-remover',
          message: resolveAPIErrorMessage(
            asyncActionState?.errorValue,
            customErrorMessage
          ),

          timeout: 4000,
        });
      }
    }, [asyncActionState?.error]);

  
    if(asyncActionState?.loaded){
      return <></>;
    }
    return (
      <Dialog
        open={open}
        onClose={toggle}
        title={title}
      >
        <section className={'no-select'} data-testid={`${id}-dialog`}>
          {!asyncActionState?.loaded && (
            <Box style={{marginTop: '36px', marginLeft: '36px', marginRight: '36px'}}>
              <Box style={{ margin: "30px 0" }}>
                {title && <Typography variant="h5">{title}</Typography>}
              </Box>
              <Box style={{ margin: "30px 0" }}>
                {message && <Typography variant="body1">{message}</Typography>}
              </Box>
              {confirmationText && (
                <>
                  <Box>
                    <Typography variant="body1">
                      Type <b>{confirmationText}</b> to confirm:
                    </Typography>
                  </Box>
                  <Box>
                    <InputContainer
                      name=""
                      data-testid="CONFIRMATION_TEXT"
                      placeholder={placeholder ?? 'Type the text here'}
                      onChange={(event) => {
                        setUserText(event.target.value);
                      }}
                    />
                  </Box>
                </>
              )}
            </Box>
          )}
        </section>
        <Box px={"30px"}>
        <DataActions 
          onCancelClick={toggle}
          asyncActionState={asyncActionState}
          skipButtonText={skipButtonText}
          submitButtonText={confirmationButtonText}
          onSubmit={onConfirm}
          disabled={(notBlank(confirmationText) && userText !== confirmationText)}
          />
          </Box>
      </Dialog>
    );
  };
  
interface DataActionsProps {
  onCancelClick?: () => void;
  asyncActionState?: AsyncActionState;
  skipButtonText?: string | JSX.Element ;
  submitButtonText?: string | JSX.Element ;
  disabled?: boolean;
  onSubmit?: () => void;
}
export  const DataActions: React.FC<DataActionsProps> = ({
    onCancelClick, 
    asyncActionState,
    skipButtonText = "Cancel",
    submitButtonText = "Submit",
    disabled = false,
    onSubmit
   }) => {
    return (
      <Box py={"30px"}>
      <Grid container style={{justifyContent: 'flex-end'}}>
      <Box display="flex" justifyContent="flex-end"
      >
        <Button
          onClick={onCancelClick}
          variant="outlined"
          color="secondary"
          data-testid="skip-button"
          disabled={asyncActionState?.loading}
          style={{marginRight: '20px'}}
        >
          {skipButtonText}
        </Button>
        <Submit
          variant='contained'
          color='primary'
          disabled={
            disabled ||
            asyncActionState?.loaded
          }
          onClick={onSubmit}
          state={asyncActionState as any}
        >
          {submitButtonText}
        </Submit>
      </Box>
      </Grid>
      </Box>
    );
  };